import { createFileRoute } from '@tanstack/react-router';

import { SettingsPage } from '@/features/settings/components/settings-page';

export const Route = createFileRoute('/_authenticated/settings')({
  /**
   * `?addFunds=true` opens the add-funds dialog on arrival.
   *
   * Exists so an email can link straight at topping up — the approval email
   * sends the first member of a new firm here, and a link to the page alone
   * leaves them hunting for the button. Adding funds is a dialog rather than a
   * route, so a search param is what makes it addressable.
   *
   * Anything other than `true` is dropped rather than rejected: a stale or
   * mistyped link should still land on Settings, not an error page.
   */
  validateSearch: (search: Record<string, unknown>): { addFunds?: true } =>
    search.addFunds === true || search.addFunds === 'true' ? { addFunds: true } : {},
  component: Settings,
});

function Settings() {
  const { addFunds } = Route.useSearch();
  return <SettingsPage openAddFunds={addFunds} />;
}
